"use client";

import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Settings } from "lucide-react";
import ThemeToggle from "./ThemeToggle";
import CurrencySelector from "./Currency";
import NoCategoryFuelSelect from "./NoCategoryFuelSelect";
import { FuelCategoryType } from "@/types/fuelCategory.types";

interface OptionsProps {
  autoScrollEnabled: boolean;
  setAutoScrollEnabled: (value: boolean) => void;
  useCategories: boolean;
  setUseCategories: (value: boolean) => void;
  currency: string;
  updateCurrency: (symbol: string) => void;
  selectedNoCategoryFuelValue: FuelCategoryType;
  setSelectedNoCategoryFuelValue: (category: FuelCategoryType) => void;
  snapRadius: number;
  setSnapRadius: (v: number) => void;
  setShouldRecalculate: (v: boolean) => void;
}

export default function OptionsTab({ 
  autoScrollEnabled, 
  setAutoScrollEnabled,
  useCategories,
  setUseCategories,
  currency,
  updateCurrency,
  selectedNoCategoryFuelValue,
  setSelectedNoCategoryFuelValue,
  snapRadius,
  setSnapRadius,
  setShouldRecalculate 
}: OptionsProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
  }, []);

  const modal = (
    <div className="license-overlay" onClick={() => setIsVisible(false)}>
      <div
        className="options-panel"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => setIsVisible(false)}
          className="close-btn license-close-button"
        >
          ✕
        </button>

        <h3 className="license-title">Settings</h3>

        <div className="options-menu">
          <div className="option-row">
            <span className="option-label">Dark Mode</span>
              <ThemeToggle />
          </div>

          <div className="option-row">
            <span className="option-label">Auto Scroll to Results</span>
            <label className="switch">
              <input
                type="checkbox"
                checked={autoScrollEnabled}
                onChange={(e) => setAutoScrollEnabled(e.target.checked)}
              />
              <span className="slider round"></span>
            </label>
          </div>

          <div className="option-row">
            <span className="option-label">Use Route Categories</span>
            <label className="switch">
              <input
                type="checkbox"
                checked={useCategories}
                onChange={(e) => setUseCategories(e.target.checked)}
              />
              <span className="slider round"></span>
            </label>
          </div>

          <div className="option-row">
            <span className="option-label">Currency</span>
            <CurrencySelector
              selectedCurrency={currency}
              onCurrencyChange={updateCurrency}
            />
          </div>

          {useCategories &&
            <div className="option-row">
              <span className="option-label">Fuel consumption to use for &quot;No Category&quot; roads</span>
              <NoCategoryFuelSelect
                selectedCategory={selectedNoCategoryFuelValue}
                onSelectedCategory={setSelectedNoCategoryFuelValue}
              />
            </div>
          }

          <div className="option-row">
            <span className="option-label">Route Snap Radius (m)</span>
            <input
              type="text"
              className="option-text-input"
              value={snapRadius}
              onChange={(e) => setSnapRadius(Number(e.target.value))}
              style={{ width: `${snapRadius.toString().length}ch` }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === "Escape") {
                  setShouldRecalculate(true);
                  e.currentTarget.blur(); 
                }
              }}
            />
          </div>

        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="license-button-container">
        <button
          onClick={() => setIsVisible(true)}
          className="button license-button"
        >
          <Settings size={25} />
        </button>
      </div>

      {isVisible && createPortal(modal, document.body)}
    </>
  );
}
